import { DateRangePicker, DateRangePickerValue } from '@mantine/dates';

interface IViewAppointmentsDateSelectProps {
  selectedDateRange: DateRangePickerValue;
  setSelectedDateRange: React.Dispatch<
    React.SetStateAction<DateRangePickerValue>
  >;
}

function ViewAppointmentsDateSelect({
  selectedDateRange,
  setSelectedDateRange,
}: IViewAppointmentsDateSelectProps) {
  return (
    <DateRangePicker
      placeholder="Pick dates range"
      value={selectedDateRange}
      onChange={setSelectedDateRange}
      size="lg"
      inputFormat="DD/MM/YYYY"
    />
  );
}

export default ViewAppointmentsDateSelect;
